export const cs = {
    LEFT: 'Vlevo: přejít na předchozí den.',
    RIGHT: 'Vpravo: Přesun na další den.',
    DOWN: 'Dolů: přechod na další řádek.',
    UP: 'Nahoru: přechod na předchozí řádek.',
    PGUP: 'PgUp: přechod na předchozí měsíc.',
    PGDOWN: 'PgDown: Přesunout na další měsíc.',
    HOME: 'Home: Přesun na předchozí rok.',
    END: 'End: Přesun na další rok.',
    ESC: 'Esc/Dnes/Zavření: zavřete kalendář.',
    TITLE: 'Klávesnice Návod'
};
